import { render, staticRenderFns } from "./SCORAD.vue?vue&type=template&id=048636c0&"
import script from "./SCORAD.vue?vue&type=script&lang=js&"
export * from "./SCORAD.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports